<script>
export default {
  name: 'SystemSettingsItemNew',
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      valid: true,
      item: {
        name: null,
        operationType: null,
        value: null,
        description: null,
      },
      rules: {
        name: [x => !!x || this.$t('validation__is_required')],
        operationType: [x => !!x || this.$t('validation__is_required')],
        value: [x => !!x || this.$t('validation__is_required')],
      },
    }
  },
  computed: {
    operationType() {
      return this.$store.getters['data/getDictionary']('operationtype')
    },
  },
  methods: {
    getValue(dictionaryName, value) {
      return this.$store.getters['data/getValueFromDictionary'](
        dictionaryName,
        value
      )
    },
    closeModal() {
      this.$emit('close-item-new')
      this.$refs.newItemForm.reset()
    },
    submit() {
      // console.log('Submit')
    },
  },
}
</script>

<template>
  <v-dialog
    v-model="dialog"
    max-width="355">
    <v-card>
      <v-card-title class="headline text-xs-center">
        %Create new% {{ $t(`dictionaries__${$route.params.dictionaryName}`).toLowerCase() }}
      </v-card-title>
      <v-card-text>
        <v-form
          ref="newItemForm"
          v-model="valid"
          lazy-validation
        >
          <v-text-field
            :label="$t('label__name')"
            v-model="item.name"
            :rules="rules.name"
            name="name"
            autocomplete="off"
            required
          />
          <v-select
            v-if="$route.params.dictionaryName === 'documenttype'"
            :items="operationType"
            :label="$t('label__activity_type')"
            v-model="item.operationType"
            :rules="rules.operationType"
            item-text="name"
            item-value="code"
            required
            autocomplete
          />
          <v-text-field
            v-if="$route.params.dictionaryName === 'alertanalyzersettings'"
            :label="$t('label__value')"
            v-model="item.value"
            :rules="rules.value"
            name="value"
            autocomplete="off"
            required
          />
          <v-text-field
            v-if="$route.params.dictionaryName !== 'alertanalyzersettings'"
            :label="$t('label__description')"
            v-model="item.description"
            name="description"
            autocomplete="off"
          />
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn
          color="secondary"
          @click="closeModal"
        >
          {{ $t('buttons__close') }}
        </v-btn>
        <v-btn
          color="primary"
        >
          {{ $t('buttons__create') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<style lang="scss" module>
@import '@design';
</style>
